import * as iban from 'iban'

export let validateBicAndAccountNumber = function (bic, account) {
    if (bic === undefined) return false; // highway to the dangerzone
    if (bic == null) return false;
    if (account == undefined) return false;
    if (account == null) return false;

    account = account.replace(/\s/g, "");
    bic = bic.replace(/\s/g, "");
    account = account.toUpperCase();
    bic = bic.toUpperCase();

    if (!(bic.length == 8 || bic.length == 11)) {
        return false;
    }

    const bicCountry = bic.substring(4, 6);
    if (bicCountry == "JP") {
        return true;
    }

    const isValidIban = iban.isValid(account);
    if (isValidIban) {
        const ibanCountry = account.substring(0, 2);
        if (ibanCountry != bicCountry) {
            return false;
        }
    }

    return isValidIban;
}

